import { isPaymentDateReadEnabled } from '@/feature/payment-date.feature';
import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { ListViewItem } from '@ingka/list-view';
import { selectAssetStatus, selectOrderType } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { translate } from '@repo/phrase';

import { MODAL } from '@/components/modals/asset-modal.types';
import { useAssetPaymentEditable } from '@/components/modals/asset-payment-modal/asset-payment-modal.hooks';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { analyticsEvents, analyticsModalIds, trackAnalyticsEvent } from '@/utils/analytics.utils.ts';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const AssetPaymentListItem = ({ onClose, context }: AssetActionProps) => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    const orderType = selectOrderType(data);
    const { isEditable: isEditPaymentDateEnabled } = useAssetPaymentEditable();

    const assetStatus = selectAssetStatus(data);
    if (!isPaymentDateReadEnabled({ assetType, orderType, assetStatus })) {
        return null;
    }

    return (
        <ListViewItem
            data-testid="order-payment-header-summary"
            title={translate('asset_payment_modal_header')}
            control="navigational"
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.ORDER_PAYMENT);

                trackAnalyticsEvent({
                    eventName: analyticsEvents.modalOpened,
                    custom: {
                        assetId,
                        id: analyticsModalIds.paymentDate,
                        isChangePaymentDateEnabled: isEditPaymentDateEnabled,
                    },
                });

                onClose?.();
            }}
        />
    );
};

export const AssetPaymentAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }
    return <AssetPaymentListItem key="order-payment-list-item" {...props} />;
};
